import { createContext, useEffect, useState } from "react";



export const authContext = createContext();


export function AuthProvider( {children} ){

let[Token , setToken] = useState(null); 


useEffect (function(){


 if (localStorage.getItem('__inventory_sys_auth_token_5f9dA72xQp__')) {
   setToken(localStorage.getItem('__inventory_sys_auth_token_5f9dA72xQp__'));
}



})

    return<authContext.Provider  value={  {Token , setToken }}>   

{children}
    
    
    </authContext.Provider>
    
}

